import { Link } from "react-router-dom";
import { Menu, Grid } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "@ant-design/icons";
import navigationConfig from "configs/NavigationConfig";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from "utils";
import { onMobileNavToggle } from "redux/features/theme";
import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const titleStyle = {
  marginTop: "-20px",
  fontSize: "1em",
};

const MenuStyle = {
  fontSize: "1em",
};

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const [role, setRole] = useState("user");
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
  } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  const hasAccessibleChild = (menuList = [], role) => {
    return menuList.some((item) => {
      if (item.access?.includes(role)) return true;
      if (item.submenu?.length > 0)
        return hasAccessibleChild(item.submenu, role);
      return false;
    });
  };

  useEffect(() => {
    try {
      if (localStorage.getItem("token")) {
        const token = localStorage.getItem("token");
        const decoded = jwt_decode(token);
        setRole(decoded.role_id);
      }
    } catch (err) {
      console.log({ err });
    }
  }, []);

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      inlineIndent={40}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {navigationConfig
        .filter((menu) => {
          const selfAccessible = menu.access?.includes(role);
          const childAccessible = hasAccessibleChild(menu.submenu, role);
          return selfAccessible || childAccessible;
        })
        .map((menu) =>
          menu.submenu.length > 0 ? (
            <Menu.ItemGroup
              key={menu.key}
              title={setLocale(localization, menu.title)}
            >
              {menu.submenu
                .filter((menu) => {
                  const selfAccessible = menu.access?.includes(role);
                  const childAccessible = hasAccessibleChild(
                    menu.submenu,
                    role
                  );
                  return selfAccessible || childAccessible;
                })
                .map((subMenuFirst) =>
                  subMenuFirst.submenu.length > 0 ? (
                    <SubMenu
                      icon={
                        subMenuFirst.icon ? (
                          <Icon component={subMenuFirst.icon} />
                        ) : null
                      }
                      key={subMenuFirst.key}
                      title={setLocale(localization, subMenuFirst.title)}
                    >
                      {subMenuFirst.submenu
                        .filter((menu) => {
                          const selfAccessible = menu.access?.includes(role);
                          const childAccessible = hasAccessibleChild(
                            menu.submenu,
                            role
                          );
                          return selfAccessible || childAccessible;
                        })
                        .map((subMenuSecond) => (
                          <Menu.Item key={subMenuSecond.key} style={MenuStyle}>
                            {subMenuSecond.icon ? (
                              <Icon component={subMenuSecond.icon} />
                            ) : null}
                            <span style={titleStyle}>
                              {setLocale(localization, subMenuSecond.title)}
                            </span>
                            <Link
                              onClick={() => closeMobileNav()}
                              to={subMenuSecond.path}
                            />
                          </Menu.Item>
                        ))}
                    </SubMenu>
                  ) : (
                    subMenuFirst.access?.includes(role) && (
                      <Menu.Item key={subMenuFirst.key} style={MenuStyle}>
                        {subMenuFirst.icon ? (
                          <Icon component={subMenuFirst.icon} />
                        ) : null}
                        <span style={titleStyle}>
                          {setLocale(localization, subMenuFirst.title)}
                        </span>
                        <Link
                          onClick={() => closeMobileNav()}
                          to={subMenuFirst.path}
                        />
                      </Menu.Item>
                    )
                  )
                )}
            </Menu.ItemGroup>
          ) : (
            menu.access?.includes(role) && (
              <Menu.Item key={menu.key} style={MenuStyle}>
                {menu.icon ? <Icon component={menu.icon} /> : null}
                <span style={titleStyle}>
                  {setLocale(localization, menu.title)}
                </span>
                {menu.path && (
                  <Link onClick={() => closeMobileNav()} to={menu.path} />
                )}
              </Menu.Item>
            )
          )
        )}
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon component={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  icon={
                    subMenuFirst.icon ? (
                      <Icon component={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon component={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon component={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
